<template>
	<w-loader v-if="account_model.loading"/>
	<w-form
		v-else-if="account"
		@submit.prevent="on_submit"
		@changed="may_submit = true"
		class="billing-administrative-contact mx-auto"
		data-discard="true"
	>
		<w-alert v-if="account_model.alert" :message="account_model.alert.message" :level="account_model.alert.level" id="address-alert-message" />
		<BillingAdministrativeContact
			:_contact="account.billing_contact"
			:countries="['US', 'CA']"
			:title="l.t('subaccounts.billing-contact', 'Billing contact')"
			:key="`billing-${l.detect()}`"
			:reset_address_on_country_change="true"
			@changed="account.billing_contact = $event"
			data-test-id="account-contacts-billing-info"
		/>
		<div class="info--text text--darken-1 w-subtitle-1 mt-10" data-test-id="acc-administrative-contact-title">
            {{ l.t('app.administrative-contact', 'Administrative contact') }}
        </div>
		<w-checkbox v-model="same_as_billing" class="mb-5">
			<template v-slot:label>
				<span class="w-body-2 text--text">
					{{l.t('account.same-as-billing-contact', 'Same as my billing contact')}}
				</span>
			</template>
		</w-checkbox>
		<transition name="collapsable">
			<BillingAdministrativeContact
				v-if="!same_as_billing"
				:_contact="account.contact"
				:key="`contact-${l.detect()}`"
				@changed="account.contact = $event"
				data-test-id="account-contacts-info"
			/>
		</transition>
		<div class="mt-10 text-center">
			<!-- <CancelChanges/> -->
			<w-btn
				:disabled="!may_submit || submitting"
				:loading="submitting"
				color="primary"
				class="ml-5"
				type="submit"
				data-test-id="account-contacts-submit-btn"
			>
				{{ l.t('app.save', 'Save') }}
			</w-btn>
		</div>
	</w-form>
</template>

<script>
	import {validate_address} from 'phoenix-session-helpers';
	import {vueComponent} from 'helpers';
	import Account from '../../../console/src/models/Account';
	import l from 'console/src/libs/lang';
	// import CancelChanges from '../../../console/src/components/elements/CancelChanges.vue';
	import BillingAdministrativeContact from '../../../console/src/components/elements/BillingAdministrativeContact.vue';

	export default {
		props: ['_account'],
		components: {
			// CancelChanges,
			BillingAdministrativeContact,
		},
		data() {
		  return {
		    l,
			account_model: new Account(this.$session, vueComponent(this)),
			account: null,
			may_submit: false,
			same_as_billing: false,
			submitting: false,
		  };
		},
		async created() {
			this.$data.account_model.loading = true;
			await this.$data.account_model.getItem();
			this.$data.account = JSON.parse(JSON.stringify(this.$data.account_model.item));
			if (this.$data.account.billing_contact && this.account.contact) {
				const billing_deep_copy = JSON.parse(JSON.stringify(this.$data.account.billing_contact));
				const administrative_deep_copy = JSON.parse(JSON.stringify(this.$data.account.contact));
				delete billing_deep_copy.id;
				delete administrative_deep_copy.id;
				this.$data.same_as_billing = JSON.stringify(billing_deep_copy) === JSON.stringify(administrative_deep_copy);
			}
		},
		methods: {
			async on_submit() {
				this.$data.submitting = true;
				if (this.$data.same_as_billing) {
					const billing_deep_copy = JSON.parse(JSON.stringify(this.$data.account.billing_contact));
					billing_deep_copy.id = this.$data.account.contact.id;
					this.$data.account.contact = billing_deep_copy;
				}
				const address_is_valid = await this.validateAddresses();
				if (address_is_valid) {
					await this.$data.account_model.updateContacts(JSON.parse(JSON.stringify(this.$data.account)))
					this.$data.may_submit = this.$data.account_model.alert?.level !=='success'
				} else {
					this.$data.account_model.alert = {
						message: l.t('contacts.invalid-address', 'Invalid address'),
						level: 'error'
					}
					window.scrollTo(0, 0);
				}
				setTimeout(() => this.account_model.alert = null, 5000)
				this.$data.submitting = false;
				return true;
			},
			async validateAddresses() {
				const billing_address_is_valid = await validate_address(this.$session, this.$data.account.billing_contact.address);
				let address_is_valid = billing_address_is_valid.success;
				if (!this.$data.same_as_billing) {
					const contact_address_is_valid = await validate_address(this.$session, this.$data.account.contact.address);
					address_is_valid = contact_address_is_valid.success && billing_address_is_valid.success;
				}

				return address_is_valid;
			}
		}
	};
</script>
